// 如何定义rule文档：https://vee-validate.logaretm.com/v4/guide/global-validators#defining-global-validators
// 官方提供的常用rules集合：https://www.npmjs.com/package/@vee-validate/rules
import { defineRule } from 'vee-validate';
import { isPlainObject } from 'lodash-es';

// defineRule('required', value => {
//   if (
//     value === '' ||
//     value === undefined ||
//     value === null ||
//     (Array.isArray(value) && value.length === 0) ||
//     (isPlainObject(value) && Object.keys(value).length === 0)
//   ) {
//     return '必填项';
//   }
//   return true;
// });

defineRule('required', (value, params, { form }) => {
  // 比如有的字段要求required的前提是该元素存在的情况下
  // refField一般是决定当前元素是否显示的字段，必须!!form[refField]的值为true，这样确保该元素是存在的
  // 默认情况下可以不指定该值，这样condition为true会继续校验
  const [errmsg, refField] = params;
  let condition = true;
  if (refField) {
    if (refField.indexOf('=') > -1) {
      const [k, v] = refField.split('=');
      condition = form[k] == v;
    } else {
      condition = !!form[refField];
    }
  }
  if (
    condition &&
    (value === '' ||
      value === undefined ||
      value === null ||
      (Array.isArray(value) && value.length === 0) ||
      (isPlainObject(value) && Object.keys(value).length === 0))
  ) {
    return errmsg || '必填项';
  }
  return true;
});
